//components
import {
  Kicker,
  KickerDot,
  SectionTitle,
  Grad,
} from '@/containers-ai/SectionHeading';
import { Container } from '@/components/Grid';

//data
import { STAGES } from '../../agents';

//styles
import {
  LineupSection,
  Life,
  Row,
  Stage,
  StageCount,
  StageCountValue,
  StageName,
  AgentLink,
  Bridge,
} from './Lineup.styles';

// The map of the eleven agents by lifecycle stage. Every link jumps to its
// place in "What we automate" just below.
export function Lineup({ content }) {
  return (
    <LineupSection id="lineup">
      <Container>
        <Kicker>
          <KickerDot />
          {content.kicker}
        </Kicker>
        <SectionTitle style={{ maxWidth: 'none' }}>
          {content.title}
          <Grad>{content.titleHighlight}</Grad>
        </SectionTitle>

        <Life>
          <Row>
            {STAGES.map((stage, index) => (
              <Stage key={stage.id}>
                <StageCount href={`#stage-${stage.id}`}>
                  <StageCountValue>{stage.slugs.length}</StageCountValue>
                  <small>{content.agentsLabel}</small>
                </StageCount>
                <StageName>{content.stages[stage.key]}</StageName>
                {stage.slugs.map((slug) => (
                  <AgentLink key={slug} href={`#agent-${slug}`}>
                    {content.agents[slug].title}
                  </AgentLink>
                ))}
                {index === STAGES.length - 1 && (
                  <AgentLink href="#custom" $custom>
                    {content.customLabel}
                  </AgentLink>
                )}
              </Stage>
            ))}
          </Row>
        </Life>

        <Bridge>
          <span />
          {content.bridge} &darr;
          <span />
        </Bridge>
      </Container>
    </LineupSection>
  );
}
